module.exports = __webpack_public_path__ + "area_beijing.633dd603.png";